import type { BUTTON_STYLE } from '@rio-cloud/rio-uikit/Button';
import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import type { ReactNode } from 'react';

export type ConfirmDialogProps = {
    show: boolean;
    title: ReactNode;
    content: ReactNode;
    confirmButtonText: ReactNode;
    cancelButtonText?: ReactNode;
    confirmButtonStyle?: BUTTON_STYLE;
    disableConfirm?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const ConfirmDialog = ({
    show,
    title,
    content,
    confirmButtonText,
    cancelButtonText = 'Cancel',
    confirmButtonStyle = 'danger',
    disableConfirm = false,
    onConfirm,
    onCancel,
}: ConfirmDialogProps) => (
    <ConfirmationDialog
        show={show}
        title={title}
        content={content}
        bsSize={Dialog.SIZE_XS}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
        confirmButtonBsStyle={confirmButtonStyle}
        disableConfirm={disableConfirm}
        onClickConfirm={onConfirm}
        onClickCancel={onCancel}
    />
);

export default ConfirmDialog;
